module.exports = __webpack_public_path__ + "img/XLSX.767521ef.png";